import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import LegalEntity from 'modules/core/store/models/LegalEntity'

import { useEmployeePersonalProvider } from 'modules/employees/components/blocks/EmployeePersonalProvider'

import BasicForm from './BasicForm'
import ExtraInformationForm from './ExtraInformationForm'
import { ScrollRowType } from './types'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  readonly?: boolean
  scrollTo?: ScrollRowType | null | undefined
  isCurrent: boolean
}

const shouldShowTaxResidence = (employee: EmployeeBlocksEmployeeFragment) =>
  hasFeature('payroll_bundle') && employee.legalEntity?.country === LegalEntity.countryDefaults.es

export const TaxResidence = observer((props: Props) => {
  const { taxResidenceForm } = useEmployeePersonalProvider()
  const { employee, readonly = false, scrollTo } = props

  const isSpanish = employee.nationality?.toLowerCase() === LegalEntity.countryDefaults.es

  const isNotResident =
    taxResidenceForm.get('is_resident').value === false ||
    taxResidenceForm.get('is_resident').value === 'false'

  if (!shouldShowTaxResidence(employee)) return null

  return (
    <Box gap="s24">
      <BasicForm
        form={taxResidenceForm}
        employeeId={employee.id}
        readonly={readonly}
        isSpanish={isSpanish}
        scrollTo={scrollTo}
      />
      {isNotResident && <ExtraInformationForm readonly={readonly} scrollTo={scrollTo} />}
    </Box>
  )
})

const TaxResidenceWrapper = (props: Props) => {
  if (!shouldShowTaxResidence(props.employee)) return null

  return (
    <PanesPadForm direction="horizontal">
      <PanesHeader
        illustration="sign-post"
        title={i18n.t('employee_form.tax_residence.title')}
        description={i18n.tCurrent('employee_form.tax_residence.description', props.isCurrent)}
      />
      <TaxResidence {...props} />
    </PanesPadForm>
  )
}

export default observer(TaxResidenceWrapper)
